/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, ContentChild, HostBinding, Input, TemplateRef } from '@angular/core';
import { isMessageBasket } from '@gh/core-messages';
import { isNotNil } from '@gh/core-util';
import { isNil } from 'lodash';
import { WidgetState } from '../../../resources/models';

@Component({
  standalone: false,
  selector: 'gh-dashboard-widget-body',
  templateUrl: 'dashboard-widget-body.component.html',
  styleUrls: ['dashboard-widget-body.component.scss'],
})
export class DashboardWidgetBodyComponent {
  @Input() state: WidgetState;

  @ContentChild(TemplateRef, { static: false }) templateRef: TemplateRef<any>;

  @HostBinding('class.m-is-loading')
  get loading(): boolean {
    return this.state.loading;
  }

  get completed(): boolean {
    return !this.state.loading && isNil(this.state.error);
  }

  @HostBinding('class.m-is-error')
  get error(): boolean {
    return !this.state.loading && isNotNil(this.state.error);
  }

  get errorText(): string {
    const { error } = this.state;

    if (error && isMessageBasket(error) && error.length > 0) {
      return error.at(0).key;
    } else {
      return 'msg_internalservererror';
    }
  }
}
